import { render } from "./OptionTable.vue?vue&type=template&id=4cbcd06b"
import script from "./OptionTable.vue?vue&type=script&lang=ts"
export * from "./OptionTable.vue?vue&type=script&lang=ts"
script.render = render

export default script